// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-quarter {
  border-radius: 5px;
  cursor: pointer;
  border: 2px solid #0669B3;
  background: white;
  color: #0669B3;
  font-size: 1.2rem;
  font-weight: 600;
  height: 60px;
  transition: 0.1s ease;
  width: 90%;
  margin: 0 10px;
}
.action-button-quarter:hover {
  transform: scale(1.015);
  background: #EDEDED;
}
.action-button-quarter:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-selected {
  background: #0669B3;
  color: white;
}
.action-button-selected:hover {
  transform: scale(1.015);
  background: #1786DB;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 250px;
  margin: 0 10px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 20px;
  transition: 0.1s ease;
  width: 40px;
  margin: 0 10px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-hide-dropdown {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none;
  background: #0669B3;
  background: #A7A9AC;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 100%;
}
.action-button-hide-dropdown:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-hide-dropdown:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-birthdate-reset {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  width: 200px;
}
.action-button-birthdate-reset:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-birthdate-reset:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-reason {
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  font-size: 0.9rem;
  height: 30px;
  padding: 0px 20px;
  margin: 0 10px;
  transition: 0.1s ease;
  white-space: nowrap;
}

.select-button-icon {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAKF;;AAFA;ECTI,kBDUmC;ECWnC,2CAAA;EDTA,eAAA;EACA,YAAA;EACA,mBDeS;ECdT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBDOa;ACFnB;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AADA;EC/BI,kBDgCmC;ECXnC,2CAAA;EDaA,eAAA;EACA,YAAA;EACA,mBDPS;ECQT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDfa;ACmBnB;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADA;ECpDI,kBDqDmC;EChCnC,2CAAA;EDkCA,eAAA;EACA,YAAA;EACA,mBD5BS;EC6BT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDpCa;ACwCnB;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADE;ECzEE,kBD0EmC;ECrDnC,2CAAA;EDuDA,eAAA;EACA,YAAA;EACA,mBDjDS;ECkDT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDzDa;AC6DnB;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADE;EC9FE,kBD+FmC;EC1EnC,2CAAA;ED4EA,eAAA;EACA,YAAA;EACA,mBDtES;ECuET,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBD9Ea;ACkFnB;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADE;ECnHE,kBDoHmC;EACnC,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,cD3FS;EC4FT,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBDnHE;ACuHR;AAFI;EACE,YAAA;EACA,mBAAA;AAIN;;AADE;EACE,mBD7GS;EC8GT,YAAA;AAIJ;AAHI;EACE,uBAAA;EACA,mBDhHa;ACqHnB;;AAFE;ECjJE,kBDkJmC;EC7HnC,2CAAA;ED+HA,eAAA;EACA,YAAA;EACA,mBDrIE;ECsIF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBDjIa;ACsInB;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AAFE;ECtKE,kBDuKmC;EClJnC,2CAAA;EDoJA,eAAA;EACA,YAAA;EACA,mBD1JE;EC2JF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBDtJa;AC2JnB;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AAFE;EC3LE,kBD4LmC;ECvKnC,2CAAA;EDyKA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDtKS;ECuKT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBD9Ka;ACmLnB;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AAFE;ECnNE,kBDoNmC;EC/LnC,2CAAA;EDiMA,eAAA;EACA,YAAA;EACA,mBDjMI;ECkMJ,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAKJ;AAHI;EACE,uBAAA;EACA,mBDxME;AC6MR;AAHI;EACE,YAAA;EACA,mBAAA;AAKN;;AAFE;ECvOE,kBDwOmC;ECnNnC,2CAAA;EDqNA,eAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,mBDlNS;ECmNT,mBDzNI;EC0NJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAIJ;AAFI;EACE,uBAAA;EACA,mBD5Na;ACgOnB;AAFI;EACE,aAAA;EACA,mBAAA;AAIN;;AADE;ECjQE,kBDkQmC;EC7OnC,2CAAA;ED+OA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBD7OS;EC8OT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAGJ;AADI;EACE,uBAAA;EACA,mBDrPa;ACwPnB;AADI;EACE,aAAA;EACA,mBAAA;AAGN;;AACE;EC3RE,kBD4RmC;EACnC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDpQS;ECqQT,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAEJ;;AAAE;EACE,aAAA;EACA,mBAAA;AAGJ;;AAAE;EACE;IACE,iBAAA;IACA,gBAAA;EAGJ;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
